import { makeStyles } from '@mui/styles'
import React, { ReactNode, useMemo } from 'react'

import ArrowRightIcon from 'assets/images/icons/arr_right.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import ThemeInterface from '@/theme-interface'
import clsx from 'clsx'
import lang from '@/lang'
import Badge from '@/modules/base/components/badge/badge'

interface AccountPopoverItemProps {
  name: string,
  title: string,
  isNew: boolean,
  icon?: ReactNode,
  styles?: { root: string },
  onClick: () => void
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '14px 32px',
    cursor: 'pointer',
    '&:hover': {
      color: theme.primaryBright,
      '& $icon': {
        fill: theme.primaryBright,
      },
    },
  },
  icon: {
    fill: theme.mode.color.default,
  },
  titleWrapper: {
    display: 'flex',
  },
  badge: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: theme.fontSizes.smaller,
    marginLeft: 10,
    height: 20,
    width: 43,
    borderRadius: 4,
  },
}), { name: 'AccountPopoverItem' })

const AccountPopoverItem = (props: AccountPopoverItemProps) => {
  const classes = useStyles()
  const { name, title, icon, isNew, styles, onClick } = props
  const iconEl = useMemo(() => {
    if (!icon) {
      return <SVGIcon className={classes.icon} svg={ArrowRightIcon} height='14px' width='14px' />
    }

    return icon
  }, [icon])

  const itemClass = clsx(classes.item, styles?.root && styles.root)
  return (
    <div data-qs-id={name} className={itemClass} onClick={onClick}>
      <div className={classes.titleWrapper}>
        <span>{title}</span>
        {isNew && <Badge label={lang.generics.new} color="primary" customClass={classes.badge} />}
      </div>
      {iconEl}
    </div>
  )
}

export default AccountPopoverItem
